import DashboardViewDetailList from "./dashboardViewDetailList";
export default DashboardViewDetailList;
